import { Card } from '@dreamtree-org/twreact-ui';

/**
 * Compact KPI tile: label, value, optional hint and trend text. Kept local because twreact-ui's
 * StatCard has no free-text hint and its 48 px icon tile crowds the two-up phone grid.
 */
export default function StatCard({ label, value, hint, trend, icon }) {
  return (
    <Card className="h-full p-4 space-y-1">
      <div className="flex items-center justify-between gap-2">
        <span className="text-sm text-muted">{label}</span>
        {icon ? <span className="text-muted" aria-hidden>{icon}</span> : null}
      </div>
      <div className="text-xl sm:text-2xl font-semibold tabular-nums break-words">{value}</div>
      {trend || hint ? (
        <div className="text-caption text-muted">
          {trend ? <span className="font-medium text-primary-700 dark:text-primary-300 mr-1">{trend}</span> : null}
          {hint}
        </div>
      ) : null}
    </Card>
  );
}
